import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { MyPublicationEditContainerProps } from "../../../../interfaces/containers";
import EntryPoint from "../../../../pages/Profile/BrandMyPublication/Edit/Edit";
import {
    getPublicationBrand, 
    getArticlesFromPublication, 
    setUploadImages,
    cleanUpdate, 
    cleanAll, 
    deletePublicationImageBrand,
    cleanImagesSaved,
} from "../../../../actions/publication";
import { 
    getYears, 
    setIsNegotiate, 
    getAdditionalCharacters, 
    setAdditionalCharacters,
    cleanGetYears,
    postPublicationsBrandImages
} from "../../../../actions/salePost";
import { 
    getModels, 
    getVersions, 
    getBrands
} from "../../../../actions/publications";
import { getMyPublicationsRequest } from "../../../../actions/profile";
import { getAdminBrand } from "../../../../actions/auth";
import { 
    updateBrandPublication,
    postBrandPublicationImages,
    cleanBrandPublicationUpdate
} from "../../../../actions/brandPublications";


function mapStateToProps(state: MyPublicationEditContainerProps) {
    return{
        publication: state.publication,
        models: state.publications.models,
        versions: state.publications.versions,
        updateReducer: state.brandPublication?.update ? {
            fetching: state.brandPublication.update.fetching,
            error: state.brandPublication.update.error,
            data: [],
            deleteImages: { fetching: "unknown" as const, data: [] },
            newImages: { fetching: "unknown" as const, data: [], count: 0, reloaded: false, reloadedName: "" }
        } : state.publication.update,
        brands: state.publications.brands,
        additionalCharacters: state.salePost.additional_characters,
        years: state.salePost.years,
        user: state.auth.user,
        adminBrand: state.auth.adminBrand,
        opportunity: state.publication.opportunity

    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getModels,
        getVersions,
        getPublication :getPublicationBrand,
        getArticlesFromPublication,
        setUploadImages,
        updatePublication: updateBrandPublication,
        cleanAll,
        cleanUpdate: cleanBrandPublicationUpdate,
        postPublicationsImages: postPublicationsBrandImages,
        deletePublicationImage: deletePublicationImageBrand,
        cleanImagesSaved,
        getMyPublicationsRequest,
        getYears,
        getBrands,
        setIsNegotiate,
        getAdditionalCharacters,
        setAdditionalCharacters,
        cleanGetYears,
        getAdminBrand
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);
